import { QUALITY_OPTIONS } from './constants';
import type { ModelConfig } from '../../services/api';
import type { GenerationMode } from './types';

interface QualitySelectorProps {
  value: string;
  onChange: (value: string) => void;
  model?: ModelConfig;
  mode?: GenerationMode;
}

const isQualityEnabled = (qualityValue: string, model?: ModelConfig, mode?: GenerationMode) => {
  if (!model) return true;

  let sizeEnabled = true;
  if (qualityValue === 'low') sizeEnabled = model.enableStandardSize !== false;
  else if (qualityValue === 'medium') sizeEnabled = model.enableHdSize !== false;
  else if (qualityValue === 'high') sizeEnabled = model.enableUhdSize !== false;

  if (!sizeEnabled) return false;

  if (mode && model.qualityCapabilities?.[mode]) {
    return model.qualityCapabilities[mode][qualityValue as 'low' | 'medium' | 'high']?.enabled !== false;
  }

  return true;
};

export function QualitySelector({ value, onChange, model, mode }: QualitySelectorProps) {
  const availableOptions = QUALITY_OPTIONS.filter((quality) => isQualityEnabled(quality.value, model, mode));

  if (availableOptions.length === 0) {
    return null;
  }

  return (
    <div>
      <label className="text-sm font-medium text-light-text mb-3 block">画质（决定最终像素）</label>
      <div className="flex gap-2">
        {availableOptions.map((quality) => (
          <button
            key={quality.value}
            onClick={() => onChange(quality.value)}
            data-active={value === quality.value}
            className="quality-btn flex-1"
          >
            {quality.label}
          </button>
        ))}
      </div>
    </div>
  );
}
